<template>
    <div id="dashboard" class="columns">
        <div id="nav" class="column is-narrow">
            <router-link to="/"
                ><img id="logo" src="../assets/spydify.png"
            /></router-link>
            <navigation></navigation>
        </div>
        <player-widget />
        <div class="column">
            <section id="section1" class="columns">
                <widget>
                    <network-widget graph-height="400" />
                </widget>
            </section>
            <section id="section2" class="columns is-multiline">
                <widget>
                    <div class="widget_title">Top Artists</div>
                    <track-artist-table-widget
                        v-if="infographics"
                        :rows="infographics.top_artists"
                        middle="genres"
                    />
                </widget>
                <widget>
                    <div class="widget_title">Top Tracks</div>
                    <track-artist-table-widget
                        v-if="infographics"
                        :rows="infographics.top_tracks"
                        middle="artists"
                    />
                </widget>
            </section>
            <attributes v-if="infographics" :dat="infographics" />
            <section id="section6" class="columns is-multiline">
                <widget>
                    <div class="widget_title">
                        Your top genres, taken from your top 20 tracks
                    </div>
                    <genre-widget
                        v-if="infographics"
                        :genres="infographics.genres"
                    />
                </widget>
            </section>
            <section id="section5" class="columns is-multiline">
                <widget>
                    <div class="widget_title">
                        Your most recently played tracks
                    </div>
                    <track-artist-table-widget
                        v-if="infographics"
                        :rows="infographics.recent_tracks"
                        middle="artists"
                    />
                </widget>
                <widget>
                    <div class="widget_title">
                        Artists you follow
                    </div>
                    <track-artist-table-widget
                        v-if="infographics"
                        :rows="infographics.followed"
                        middle="genres"
                    />
                </widget>
            </section>
            <section id="section4" class="columns is-multiline">
                <widget>
                    <div class="widget_title">Global top artists</div>
                    <track-artist-table-widget
                        :rows="dailyTopArtists"
                        middle="NA"
                    />
                </widget>
            </section>
        </div>
    </div>
</template>

<script>
import NetworkWidget from "@/components/NetworkWidget";
import Navigation from "../components/Navigation";
import Widget from "../components/Widget";
import PercentageWidget from "../components/PercentageWidget";
import PlayerWidget from "../components/PlayerWidget";
import DataSongs from "../components/DataSongs";
import Attributes from "../components/dashboard/attributes";
import api from "../helpers/api";
import TrackArtistTableWidget from "../components/TrackArtistTableWidget";
import GenreWidget from "../components/GenreWidget";

export default {
    name: "Dashboard",
    components: {
        GenreWidget,
        TrackArtistTableWidget,
        PlayerWidget,
        Attributes,
        PercentageWidget,
        Widget,
        Navigation,
        NetworkWidget,
        DataSongs
    },
    data() {
        return {
            infographics: null
        };
    },
    async created() {
        let res = await api.get("infographics");
        this.infographics = res.data;
    },
    computed: {
        dailyTopArtists() {
            if (!this.$store || !this.$store.state.popular_artists) {
                return [];
            }
            return this.$store.state.popular_artists.graph
                .filter(d => d.list_index !== -1)
                .sort((b, a) => a.popularity - b.popularity)
                .map(a => {
                    return { ...a, image: a.image_url };
                });
        }
    }
};
</script>

<style lang="scss">
.widget_title {
    font-weight: bold;
    font-size: 1.3em;
    text-align: center;
}
#dashboard {
    background-color: #212121;
    padding: 8px;

    #network-graph {
        background: #212121;
    }
}

#logo {
    top: 15px;
    max-width: 200px;
    position: sticky;

    @media only screen and (max-width: 768px) {
        & {
            position: initial;
            top: 0;
        }
    }
}

#nav {
    text-align: center;
}

section:not(:last-child) {
    margin-bottom: 40px;
}

.largeSectionPlaceholder {
    padding-top: 12rem;
    padding-bottom: 12rem;
    text-align: center;
}

.smallSectionPlaceholder {
    padding-top: 6rem;
    padding-bottom: 6rem;
    text-align: center;
}
</style>
